// 个人主页
export default {
  routes: [
    {
      path: '/publish-h5',
      name: 'publish',
      meta: {
        title: '发布',
        pageId: 'V9586',
        isAutoPV: false
      },
      component: () => import(/* webpackChunkName: "publishH5" */ '../views/publish/index.vue')
    },
    {
      path: '/prerender/publish-h5',
      name: 'pre-render-publish-h5',
      meta: {
        desc: '发布'
      },
      component: async () => await import('../views/publish/index-prerender.vue')
    }
  ]
}
